/**
 * 部屋による絞り込み
 *
 * @param {Array<ReservationRecord>} records
 * @param {Array<string>} rooms
 */
export default function (records, rooms) {
    if (rooms.length === 0) {
        return records;
    }

    return records.filter((record) => {
        return rooms.some((room) => {
            // コードまたは部屋名の一致でtrue
            return record.code === room || record.room === room;
        });
    });
}
